exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.debug-panel[data-v-2a5f57d0] {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n", ""]);

// exports
